export default __webpack_public_path__ + "static/media/virtual.4b86abb5.jpeg";